export const DATE_FORMAT: string = 'dd/MM/yyyy HH:mm';
export const RESEND_OTP_IN_SEC: number = 20;
export const OTP_LENGTH: number = 4;
